export default __webpack_public_path__ + "static/55-d19d1b0acf5f944a03a15dbe1451f518.gif";